import React, { useEffect } from 'react';

import RiskIcon from '../../assets/images/meters/risks.svg';
import ActionIcon from '../../assets/images/meters/actions.svg';
import ControlIcon from '../../assets/images/meters/controls.svg';
import AppetiteIcon from '../../assets/images/meters/appetite.svg';
import { AiOutlineRadarChart } from "react-icons/ai";


import { connect } from "react-redux";
import { compose } from "redux";

import { getMetrics } from "../../store/actions/dashboardActions";


const Meters = ({mode, metrics, getMetricsFN, department_id, risk_id}) => {

    //////console.log('current mode', department_id);

    ////console.log("metrics:", metrics);
    useEffect(() => {
        //console.log("Mode", mode, "department_id", department_id, "risk_id", risk_id)
        getMetricsFN(mode, department_id, risk_id);
    }, [department_id]);

    //console.log("Metrics:", metrics);

    return (
        <div className="flex justify-center items-center bg-white p-6 pt-0 pr-0 gap-x-32">
            {/* Risks */}
            <div className="flex items-center">
                <img
                    src={RiskIcon}
                    alt="Risks Icon"
                    className="h-10 w-10 mr-2"
                />
                <div className="flex flex-col">
                    <div className="text-xl md:text-lg font-bold">{mode === "risk" ? metrics.risk_owner : metrics.risks}</div>
                    <div className="text-lg md:text-lg text-gray-600">{mode === "risk" ? "Owner" : "Risks"}</div>
                </div>
            </div>

            {/* Controls */}
            <div className="flex items-center">
                <img
                    src={ControlIcon}
                    alt="Controls Icon"
                    className="h-10 w-10 mr-2"
                />
                <div className="flex flex-col">
                    <div className="text-xl md:text-lg font-bold">{metrics.controls}</div>
                    <div className="ext-lg md:text-lg text-gray-600">Controls</div>
                </div>
            </div>

            {/* Actions */}
            <div className="flex items-center">
                <img
                    src={ActionIcon}
                    alt="Actions Icon"
                    className="h-8 w-8 mr-2"
                />
                <div className="flex flex-col">
                    <div className="text-xl md:text-lg font-bold">{metrics.actions}</div>
                    <div className="ext-lg md:text-lg text-gray-600">Actions</div>
                </div>
            </div>

            {mode === "department" && (
                <>
                    {/* Actions */}
                    <div className="flex items-center">
                        <AiOutlineRadarChart
                            alt="Actions Icon"
                            className="h-10 w-10 mr-2 text-[#05769D]"
                        />
                        <div className="flex flex-col">
                            <div className="text-xl md:text-lg font-bold">{metrics.risk_appetite}</div>
                            <div className="ext-lg md:text-lg text-gray-600">Appetite</div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};


const mapStateToProps = (state) => {
    return {

        //token: state.auth.token,
        //departments: state.department.departments,
        //department_id: state.department.department_id
        metrics: state.dashboard.metrics,


    };
};

const mapDispatchToProps = (dispatch) => {
    return {

        getMetricsFN: (mode, department_id, risk_id) => dispatch(getMetrics(mode, department_id, risk_id)),
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Meters);